import React, { useState } from "react";
import socket from "../../assets/socketConnection";
import {
  Container,
  OnlinePaymentBtn,
  OnlinePaymentPrice,
  Price,
  ModalText,
  Btn,
} from "./onlinePayment.styles";
import { Modal } from "antd";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
const OnlinePayment = ({ bit, won_price }) => {
  const [visible, setVisible] = useState(false);
  const [linkRes, setLinkRes] = useState({});
  const Initial = bit.payments.initial.amount;
  const Insurence = bit.insurance.price;
  console.log("bijan",bit)
  const PaymentAmount =
    Initial === 0 ? won_price + Insurence : won_price + Insurence - Initial;
  const Payment = () => {
    socket.emit("online_payment", { load_id: bit._id });
    socket.on("response_with_link", (res) => {
      //   console.log(res);
      setVisible(true);
      setLinkRes(res);
    });
  };
  console.log(linkRes);

  const LinkUrl = () => {
    window.location.replace(linkRes.link);
  };
  const handleCancel = () => {
    setVisible(false);
  };
  return (
    <Container>
      <div style={{ color: "#2a2e43", fontSize: "14px" }}>
        آنلاین پرداخت کنید ، ژتون بگیرید.
      </div>
      {/* <OnlinePaymentPrice>
        <div>مبلغ قابل پرداخت توسط شما</div>
        <Price>{toSeperatedNum(toPersianNum(PaymentAmount))} تومان</Price>
      </OnlinePaymentPrice> */}
      <OnlinePaymentBtn onClick={Payment}>پرداخت</OnlinePaymentBtn>
      <Modal
        footer={null}
        closable={false}
        visible={visible}
        onCancel={handleCancel}
      >
        <ModalText>
          {linkRes.message}
          <Btn onClick={LinkUrl}>{linkRes.btn_text}</Btn>
        </ModalText>
      </Modal>
    </Container>
  );
};

export default OnlinePayment;
